export const validUrl = (enlace) => {
    if (!enlace) return false;
    // Expresión regular para validar una URL
    const regex = /^(ftp|http|https):\/\/[^ "]+$/;

    try {
        new URL(enlace);
        return regex.test(enlace);
    } catch (error) {
        return false;
    }
};

/** Añade https:// si el usuario omitió el protocolo. */
export const normalizeUrl = (value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
};

/** Indica si el texto parece un enlace real (no una palabra suelta). */
export const looksLikeUrlIntent = (value) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return false;
    if (/^https?:\/\//i.test(trimmed)) return true;
    if (/^www\./i.test(trimmed)) return true;
    return /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}(?:[/?#][^\s]*)?$/i.test(trimmed);
};

/**
 * Si el mensaje es solo un enlace (pegado o escrito), devuelve la URL normalizada.
 * Mensajes con espacios o varias líneas se tratan como texto normal.
 * @param {string} text
 * @returns {string | null}
 */
export const parseChatUrlMessage = (text) => {
    const trimmed = String(text || '').trim();
    if (!trimmed) return null;

    const lines = trimmed.split(/\r?\n+/).map((line) => line.trim()).filter(Boolean);
    if (lines.length !== 1) return null;

    const single = lines[0];
    if (!looksLikeUrlIntent(single)) return null;

    const normalized = normalizeUrl(single);
    return validUrl(normalized) ? normalized : null;
};